import { appPath } from '../../routes/paths';
import { NAV_GROUPS } from './navConfig';
import { getSetupNavLabel } from '../settings/setupRoutes';

const EXTRA_ROUTE_LABELS: Record<string, string> = {
  [appPath('/profile')]: 'Profile',
  [appPath('/kundali')]: 'Kundali',
  [appPath('/unauthorized')]: 'Unauthorized',
};

export function getNavLabelForPath(pathname: string): string | null {
  return getNavContextForPath(pathname).label;
}

export function getNavContextForPath(pathname: string): {
  label: string | null;
  groupLabel: string | null;
} {
  const extra = EXTRA_ROUTE_LABELS[pathname];
  if (extra) {
    return { label: extra, groupLabel: null };
  }

  if (pathname.startsWith(`${appPath('/kundali')}/`)) {
    return { label: 'Kundali', groupLabel: 'Contacts' };
  }

  for (const group of NAV_GROUPS) {
    for (const item of group.children) {
      if (item.key === pathname) {
        return { label: item.label, groupLabel: group.label };
      }
    }
  }

  const setupLabel = getSetupNavLabel(pathname);
  if (setupLabel !== null) {
    return { label: setupLabel, groupLabel: null };
  }

  return { label: null, groupLabel: null };
}

export function getDocumentTitle(pathname: string): string {
  const label = getNavLabelForPath(pathname);
  if (!label) {
    return 'Crowpeaks';
  }
  return `${label} · Crowpeaks`;
}
